import React from "react";

import { MemberProfileActivityEntry } from "../../../component-library";

export const WaitListAddedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { added_by_name, removed_by_name, wait_list_reason } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="WaitlistedIcon"
      iconSrc="icons/common/task/InsuranceBlue.svg"
      localDateTime={localCreatedTime}
      subTitle={`Waitlisted (Reason: ${wait_list_reason})`}
      title="Waitlist Change"
    >
      <div className="fs-14">{`Updated By: ${added_by_name ?? removed_by_name}`}</div>
    </MemberProfileActivityEntry>
  );
};

export const WaitListRemovedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { added_by_name, removed_by_name } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="WaitlistRemovedIcon"
      iconSrc="icons/common/task/InsuranceBlue.svg"
      localDateTime={localCreatedTime}
      subTitle="Removed from waitlist"
      title="Waitlist Change"
    >
      <div className="fs-14">{`Updated By: ${added_by_name ?? removed_by_name}`}</div>
    </MemberProfileActivityEntry>
  );
};
